import React from "react";
import "../../operator-finance.css";

/* Semicircle arc geometry shared by track and fill. */
const ARC_D = "M 14 86 A 70 70 0 0 1 154 86";
const ARC_LEN = Math.PI * 70;

const clamp01 = (v) => Math.min(1, Math.max(0, Number(v) || 0));

/**
 * Half-moon credit gauge for the loan desk.
 * tone: "ok" (green) | "locked" (red) | "active" (blue).
 */
const LoanCreditGauge = ({
  fraction,
  tone = "ok",
  value,
  label,
  minLabel,
  maxLabel,
  foot,
}) => {
  const frac = clamp01(fraction);

  return (
    <div className="oc-fin-gauge" role="img" aria-label={`${label}: ${value}`}>
      <svg className="oc-fin-gauge-svg" viewBox="0 0 168 96" aria-hidden>
        <path d={ARC_D} className="oc-fin-gauge-track" strokeWidth="10" />
        <path
          d={ARC_D}
          className={`oc-fin-gauge-fill oc-fin-gauge-fill-${tone}`}
          strokeWidth="10"
          strokeDasharray={ARC_LEN}
          strokeDashoffset={ARC_LEN * (1 - Math.max(frac, 0.005))}
        />
      </svg>
      <div className="oc-fin-gauge-readout">
        <strong className="tabular-nums">{value}</strong>
        <em>{label}</em>
      </div>
      {minLabel != null || maxLabel != null ? (
        <div className="oc-fin-gauge-band" aria-hidden>
          <span>{minLabel}</span>
          <span>{maxLabel}</span>
        </div>
      ) : null}
      {foot ? <p className="oc-fin-gauge-foot">{foot}</p> : null}
    </div>
  );
};

export default LoanCreditGauge;
